import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { CHAIN_ALERTS_API_BASE_URL } from '@/features/chainAlerts/constants'

export type AlertType = 'info' | 'warning' | 'danger'

export interface ChainAlert {
  id: string
  title: string
  chainId: string
  content: string
  type: AlertType
}

export interface ChainAlertsResponse {
  alerts: ChainAlert[]
}

export const chainAlertsApi = createApi({
  reducerPath: 'chainAlertsApi',
  baseQuery: fetchBaseQuery({ baseUrl: CHAIN_ALERTS_API_BASE_URL }),
  endpoints: (builder) => ({
    getChainAlerts: builder.query<ChainAlertsResponse, { chainId: string }>({
      query: ({ chainId }) => ({
        url: `chain/${chainId}/alerts`,
      }),
    }),
  }),
})

export const { useGetChainAlertsQuery } = chainAlertsApi
